export default __webpack_public_path__ + "static/media/RTR2004V_LateralIzq.83ddfdc2.webp";